import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { NumberInputComponent } from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-stability-conditions',
  templateUrl: './stability-conditions.component.html',
  styleUrl: './stability-conditions.component.css',
  imports: [FormsModule, NumberInputComponent],
})
export class StabilityConditionsComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'operational';
  sectionId = 'stabilityConditions';
  events = injectDispatch(offshoreOperationalEvents);
  operationalStore = inject(OffshoreOperationalFormStore);
  offshoreStore = inject(OffshoreReportStore);
}
